import { useEffect, useRef, useState } from 'react'
import { useArrangementStore } from '../../state/arrangementStore'
import { snapshotEditorState } from '../../state/snapshot'
import './CaptureSegmentModal.css'

interface CaptureSegmentModalProps {
  onClose: () => void
}

export function CaptureSegmentModal({ onClose }: CaptureSegmentModalProps) {
  const order = useArrangementStore((s) => s.order)
  const captureSegment = useArrangementStore((s) => s.captureSegment)
  const [name, setName] = useState(`Segment ${order.length + 1}`)
  const inputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    const timer = window.setTimeout(() => {
      inputRef.current?.focus()
      inputRef.current?.select()
    }, 20)
    return () => window.clearTimeout(timer)
  }, [])

  const submit = () => {
    captureSegment(name, snapshotEditorState())
    onClose()
  }

  return (
    <div className="capture-backdrop" onClick={onClose}>
      <form
        className="capture-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Save segment"
        onClick={(e) => e.stopPropagation()}
        onSubmit={(e) => {
          e.preventDefault()
          submit()
        }}
      >
        <div className="capture-header">
          <span className="capture-title">SAVE SEGMENT</span>
          <button
            type="button"
            className="capture-close"
            onClick={onClose}
            aria-label="Cancel save"
          >
            ✕
          </button>
        </div>
        <label className="capture-field">
          <span className="capture-label">NAME</span>
          <input
            ref={inputRef}
            className="capture-input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={32}
            aria-label="Segment name"
          />
        </label>
        <div className="capture-actions">
          <button type="button" className="capture-cancel" onClick={onClose}>
            CANCEL
          </button>
          <button type="submit" className="capture-save">
            SAVE
          </button>
        </div>
      </form>
    </div>
  )
}
